export const environment = {
  production: false,
  apiBaseUrl: 'https://digitalmarketing.mo.vc'
};
